import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Link from ".";
var useStyles = makeStyles()(function(theme) {
    return {
        root: {
            color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.primary.main,
            textDecoration: "none",
            "&:hover": {
                color: theme.palette.mode === "dark" ? theme.palette.primary.light : theme.palette.primary.light
            }
        }
    };
});
export var ContrastLink = function(_param) {
    var children = _param.children, className = _param.className, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
        className: classes.root
    }, rest), {
        children: children
    }));
};
export default ContrastLink;
